import { DOWNLOADABLE_FILE_TYPES, VIEWABLE_FILE_TYPES } from '@exam-center/utils';

export function getFilePreviewModeByType(type: string) {
  if (VIEWABLE_FILE_TYPES.includes(type)) return 'preview' as const;
  if (DOWNLOADABLE_FILE_TYPES.includes(type)) return 'download' as const;
}
